export const PasswordPolicyMsg = {
  passRequiredErrMsg: 'Password is required!',
  passTooShortErrMsg: 'Password must be at least 8 characters long!',
  passTooLongErrMsg: 'Password cannot be longer than 30 characters!',
  passWhitespaceErrMsg: 'Password cannot contain spaces!',
  passIllegalCharErrMsg: 'Password contains an unsupported character!',
  passNoUppercaseErrMsg: 'Password must contain at least one uppercase letter!',
  passNoLowercaseErrMsg: 'Password must contain at least one lowercase letter!',
  passNoDigitErrMsg: 'Password must contain at least one digit!',
  passNoSpecialCharErrMsg: 'Password must contain at least one special character!',
  passNumericSequenceErrMsg: 'Password cannot contain a sequence of numbers such as 1234 or 4321!',
  passAlphabeticSequenceErrMsg: 'Password cannot contain a sequence of letters such as abcd or dcba!',
  passRepeatedCharErrMsg: 'Password cannot contain the same character repeated such as 111 or aaa!',
  passKeyboardPatternErrMsg: 'Password cannot contain a keyboard pattern such as qwerty or asdf!',
  passCommonlyUsedErrMsg: 'This password is too common! Please choose a different one!',
  passContainsNameErrMsg: 'Password cannot contain any part of your name!',
  passContainsUserNameErrMsg: 'Password cannot contain any part of your username!',
  passContainsPhoneErrMsg: 'Password cannot contain any part of your phone number!',
  passContainsEmailErrMsg: 'Password cannot contain any part of your email address!',
  passContainsTinErrMsg: 'Password cannot contain any part of your TIN!',
  passContainsDobErrMsg: 'Password cannot contain your date of birth!',
  passContainsBirthYearErrMsg: 'Password cannot contain your birth year!',
  passSameAsOldErrMsg: 'New Password cannot be same as your Old Password!',
  passMismatchErrMsg: "New Password and Confirm Password didn't match!",
  passNoPersonalInfoHint: "Don't use any personal information . (Name, Email, Mobile, TIN, DoB)"
};
